const componentWrapperCls = "_uihc1jdno51";

export { componentWrapperCls };
import "./annotated-embed-iframe.style.linaria.module.css";
//# sourceMappingURL=annotated-embed-iframe.style.js.map
